import type { ClinicSession } from "@auth/clinicAuthClient";
import type { ClinicUser } from "@users/userClient";
import { createContext, useContext } from "react";

export interface UserContextValue {
  session: ClinicSession | null;
  currentUser: ClinicUser | null;
  isUserAuthed: boolean;
  submitAccessCode: (code: string, pin: string) => Promise<void>;
  switchUser: () => void;
}

export const UserContext = createContext<UserContextValue | null>(null);

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used within UserProvider");
  return ctx;
};
